import { useState, useEffect, useCallback } from 'react';
//import { useDispatch } from 'react-redux';
// Removed Redux auth selectors - now using useAuth() hook
import { getUserProfile } from '../../../services/userService';
import { useUserData } from '../../../hooks/useUserData';

export const useUserProfile = (_, location) => {
  const [userProfilePicture, setUserProfilePicture] = useState('');
  const [defaultFacilityName, setDefaultFacilityName] = useState('');
  const { user } = useUserData();
  // const user = useAuth().user; // Now using useAuth() hook 
//const dispatch = useDispatch();
  
  // Use the new useUserData hook for consistent data structure
  const { defaultFacility } = useUserData();

  // Get profile picture from Redux or fetch if missing
  const fetchUserProfilePicture = useCallback(async () => {
    if (!user?.uid) return;

    // If profile data is missing, fetch it
    if (!user.profilePictureUrl && !user.profileChecked) {
      try {
        const profile = await getUserProfile(user.uid);
        setUserProfilePicture(profile.profilePictureUrl || '');
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    } else {
      setUserProfilePicture(user.profilePictureUrl || '');
    }
  }, [user]);

  // Fetch default facility name from user facilities
  const fetchDefaultFacilityName = useCallback((userFacilities) => {
    if (defaultFacility?.id && userFacilities.length > 0) {
      // defaultFacility is now the complete facility object, extract the ID
      const facilityId = defaultFacility.id;
      const facility = userFacilities.find(f => f.id === facilityId);
      if (facility) {
        setDefaultFacilityName(facility.name || '');
      } else {
        setDefaultFacilityName('');
      }
    } else {
      setDefaultFacilityName('');
    }
  }, [defaultFacility]);

  // Initial fetch of user profile picture
  useEffect(() => {
    fetchUserProfilePicture();
  }, [fetchUserProfilePicture]);

  // Refresh profile picture when navigating back from My Account page
  useEffect(() => {
    if (location.pathname !== '/my-account' && user?.uid) {
      fetchUserProfilePicture();
    }
  }, [location.pathname, fetchUserProfilePicture, user?.uid]);

  return {
    userProfilePicture,
    defaultFacilityName,
    setDefaultFacilityName: (name) => setDefaultFacilityName(name),
    fetchDefaultFacilityName,
    refreshProfilePicture: fetchUserProfilePicture
  };
}; 